<template>
  <div class="main-menu">
    <el-container>
      <el-header height="64px" style="z-index: 999">
        <SWSHeader/>
      </el-header>
      <el-container>
        <el-aside :width="width" style="overflow: visible;background-color:#56c02b;z-index:1000;position: relative;">
          <aside-navigation-menu-with-collapse :width="width" @switchHandle="switchHandle" v-bind="{activeTagIndex:activeTagIndex,menuItems:this.mainMenuFromStore}"/>
        </el-aside>
        <el-container>
          <el-main>
            <div class="bpo-breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item v-for="(item,index) in historyPages"
                :key="index"
                :to="{name: item.name ,params:item.params }"
                style="z-index:999;position: relative;">
                <span id="b-click">{{item.meta.name}}</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item>{{this.$route.meta.name}}</el-breadcrumb-item>
            </el-breadcrumb>
            </div>
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"/>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"/>
          </el-main>
        </el-container>
      </el-container>
      <el-footer class="bpo-footer" height="40px">
        <SWSFooter/>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import SWSHeader from '@/components/common/SWSHeader'
import SWSFooter from '@/components/common/SWSFooter'
import AsideNavigationMenuWithCollapse from '@/components/common/AsideNavigationMenuWithCollapse'
import {mapState} from 'vuex'

export default {
  name: 'MainMenu',
  data(){
    return {
	  width:'240px',
      activeTagIndex: '',
      breadcrumb:[],
      historyPages:[]
    }
  },
  props: {
    menuType: {
      default: 'vertical-collapse',
      type: String
    }
  },
  computed: {
    ...mapState({mainMenuFromStore:'mainMenu'})
  },
  created() {
    this.$store.dispatch('refreshMainMenu')
    this.$store.dispatch('refreshDictData')
    this.$store.dispatch('refreshOriginList')
    this.$store.dispatch('refreshOrgList')
    this.$store.dispatch('refreshRoleList')
    this.$store.dispatch('refreshApplyUsrList')
    this.$store.dispatch('refreshSettleUsrList')
    this.$store.dispatch('refreshSearchUsrList')
    if (this.$route.meta.breadCrumbLv > 1) {
	  this.historyPages = this.$store.getters.historyPages();
	}
	this.activeTagIndex = this.$route.path
	if (_.isEmpty(this.activeTagIndex)) {
	  this.activeTagIndex = '/sws/platform/init'
	}
  },
  components: {
    SWSHeader,
    AsideNavigationMenuWithCollapse,
    SWSFooter
  },
  watch:{
	'$route': function(to, from) {
      this.activeTagIndex = to.path
	  if (this.activeTagIndex.indexOf('/sws/report/analysis/') != -1) {
	    this.activeTagIndex = '/sws/report/analysis'
	  }
      if ('dummy' !== from.name && 'dummy' !== to.name) {
        if (undefined == from.meta.name || 'Error' == from.name) {
          // unknown page
          this.historyPages = this.$store.getters.historyPages();
        } else {
          let tmp = {
            name: from.name,
            meta: from.meta,
            params: from.params,
          }
          if (null != to.meta.breadCrumbLv && to.meta.breadCrumbLv == 1) {
            this.historyPages = []
          } else {
            let subIndex = -1;
            for (let index = 0; index < this.historyPages.length; index++) {
              if (to.name == this.historyPages[index].name) {
                subIndex = index;
                //break
                index = this.historyPages.length;
              }
            }
            if (subIndex != -1) {
              this.historyPages = this.historyPages.slice(0, subIndex);
            } else {
              this.historyPages.push(tmp);
            }
          }
          this.$store.commit('saveHistoryPages', this.historyPages);
        }
      } else if (from.name === 'dummy') { // dummy刷新路由中间跳转页面
        if (null != to.meta.breadCrumbLv && to.meta.breadCrumbLv == 1) {
          this.historyPages = []
          this.$store.commit('saveHistoryPages', this.historyPages)
        }
      }
    }
  },
  methods: {
    switchHandle: function(switchFg) {
      if (switchFg) {
        this.width = '55px'
      } else {
        this.width = '240px'
      }
    }
  }
}
</script>

<style scoped>
  .main-menu{
    overflow: hidden;
    height: 100vh;
    width: 100vw;
  }
  .el-main {
    height: 100%;
    padding-left: 0;
    padding-right: 0;
  }
  .el-container {
    height: 100%;
    min-width: 1000px;
  }
  .bpo-breadcrumb {
    width: 100%;
    text-align: center;
  }
  .el-breadcrumb {
    width: 100%;
    line-height: 35px;
    display: inline-block;
    background: #F4F4F5;
    height: 35px;
  }
  #b-click {
    color:#409EFF;
  }
  #b-click:hover {
    color: #8CBCE7;
    cursor: pointer;
  }
  .el-breadcrumb__item:first-child {
    margin-left: 15px;
  }
  input:disabled,textarea:disabled{
    opacity: 1;
    -webkit-text-fill-color: black;
  }
  .bpo-footer.el-footer {
    z-index:1000;
  }
</style>
